import { useEffect } from "react";
import { Link as RouterLink } from "react-router-dom";

export default function NotFound() {
  useEffect(() => {
    document.title = "Sayfa Bulunamadı (404) | Antalya Psikolog Aysun Şeremet";
    const meta = document.querySelector('meta[name="robots"]');
    const prev = meta ? meta.getAttribute("content") : null;
    if (meta) meta.setAttribute("content", "noindex, follow");
    return () => {
      if (meta && prev) meta.setAttribute("content", prev);
    };
  }, []);

  return (
    <main className="min-h-[60vh] flex items-center justify-center px-6 py-20">
      <div className="text-center max-w-xl">
        <p className="text-pink-500 font-semibold text-sm tracking-widest uppercase">
          404
        </p>
        <h1 className="mt-3 text-3xl sm:text-4xl font-semibold text-gray-900">
          Sayfa bulunamadı
        </h1>
        <p className="mt-4 text-gray-600">
          Aradığınız sayfa taşınmış ya da hiç var olmamış olabilir. Aşağıdaki
          bağlantılardan devam edebilirsiniz.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <RouterLink
            to="/"
            className="rounded-full bg-gray-900 px-6 py-2.5 text-sm font-semibold text-white hover:bg-gray-700 transition-colors"
          >
            Anasayfaya dön
          </RouterLink>
          <RouterLink
            to="/randevu-al"
            className="rounded-full bg-pink-500 px-6 py-2.5 text-sm font-semibold text-white hover:bg-pink-600 transition-colors"
          >
            Randevu Al
          </RouterLink>
          <a
            href="https://wa.me/905372153407"
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-full border border-green-500 px-6 py-2.5 text-sm font-semibold text-green-600 hover:bg-green-50 transition-colors"
          >
            WhatsApp ile iletişim
          </a>
        </div>

        <div className="mt-10 text-sm text-gray-500">
          <p className="mb-2">Sık ziyaret edilen sayfalar:</p>
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2">
            <RouterLink to="/hakkimda" className="hover:text-pink-600">Hakkımda</RouterLink>
            <RouterLink to="/calisma-alanlari" className="hover:text-pink-600">Çalışma Alanları</RouterLink>
            <RouterLink to="/hizmetlerimiz" className="hover:text-pink-600">Seans Süreci</RouterLink>
            <RouterLink to="/blog" className="hover:text-pink-600">Blog</RouterLink>
            <RouterLink to="/iletisim" className="hover:text-pink-600">İletişim</RouterLink>
          </div>
        </div>
      </div>
    </main>
  );
}
